import { render, staticRenderFns } from "./DaGiustificare.vue?vue&type=template&id=4a76aa86&scoped=true&"
import script from "./DaGiustificare.vue?vue&type=script&lang=js&"
export * from "./DaGiustificare.vue?vue&type=script&lang=js&"
import style0 from "./DaGiustificare.vue?vue&type=style&index=0&id=4a76aa86&prod&lang=css&"
import style1 from "./DaGiustificare.vue?vue&type=style&index=1&id=4a76aa86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a76aa86",
  null
  
)

export default component.exports